import { placeParamsToURL } from 'helpers/CommonHelper';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // if using react-router
import { adminMainRoutes } from 'routes/admin/AdminRoutes';

const Error404 = (props: { homePageURL?: any }) => {
  const { homePageURL = placeParamsToURL(adminMainRoutes.dashboard.path) } = props;
  const navigate = useNavigate();

  return (
    <Container fluid className="d-flex vh-100 justify-content-center align-items-center bg-light">
      <Row className="text-center">
        <Col>
          <h1 className="display-1 fw-bold text-danger">{'404'}</h1>
          <h3 className="mb-4">{'Page not found.'}</h3>
          <p className="mb-4 text-muted">
            The page you are looking for might be temporarily unavailable or you might have mistyped
            the URL.
          </p>
          <Button variant="primary" size="lg" onClick={() => navigate(homePageURL)}>
            Go Back Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Error404;
